import request from '@/utils/request'

// 获取用户配置
export function getConfigInfoApi(params) {
  return request.get('/userInfo/getConfigInfo', { params })
}

// 修改用户配置信息
export function setConfigInfoApi(data) {
  return request.post('/userInfo/setConfig', data)
}

// 初始化配置 大刷
export function initConfigApi(params) {
  return request.get('/initConfig')
}

// 账号归属绑定  登录后绑定接口（参数 id）
export function bindAccountOwnershipApi(data) {
  return request.post('/v1/bindAccountOwnership', data)
}
